import { createGlobalContext } from 'sierra-client/context/create-context'
import { NotificationPushType } from 'sierra-client/state/notifications/types'

export const initialState: { notifications: NotificationPushType[]; isSanaUpdated: boolean } = {
  notifications: [],
  isSanaUpdated: false,
}

export const NotificationContext = createGlobalContext(initialState)
